<div class="filter-members">
  <div class="avatar-list">
      <nz-avatar *ngFor="let member of members.slice(0, maxVisibleAvatars); let i = index"
                 [ngClass]="{ 'selected': isSelected(member), 'inactive-member': !isMemberActive(member)}" [nzSrc]="member.avatar ? member.avatar : null"
                 [nzText]="!member.avatar ? (member.label | capitalize) : null" [ngStyle]="{
        'background-color': getBackgroundColor(member.label),
        'color': '#fff',
        'z-index': isSelected(member) ? 10 : (maxVisibleAvatars - i),
        'margin-left': i > 0 && !isSelected(member) ? '-2%' : '0',
        'position': 'relative',
      }" nz-tooltip [nzTooltipTitle]="isMemberActive(member) ? member.label : member.label + ' (Inactive)'" (click)="toggleMemberSelection(member)">
      </nz-avatar>
    <div class="more-avatar">
      <nz-avatar *ngIf="members.length > maxVisibleAvatars" [nzText]="'+' + (members.length - maxVisibleAvatars)"
        nz-dropdown [nzDropdownMenu]="menu" nzTrigger="hover" [ngStyle]="{'background-color': '#ececec',
      'color': '#000',
      'position': 'relative',
      'cursor': 'pointer',
      'box-shadow': isDropdownSelected() ? '0 0 0 2px #1890ff' : 'none'}" nzClickHide="false">
      </nz-avatar>
    </div>

    <nz-dropdown-menu #menu="nzDropdownMenu">
  <app-input [(value)]="filterText" [isFullSize]="true" (valueChange)="fliterMember()"></app-input>
      <ul nz-menu nzDropdownMenu class="fliter-drop">
        <li nz-menu-item *ngFor="let member of fliterMembers" [nzValue]="member.value">
          <label nz-checkbox [(ngModel)]="member.checked" (ngModelChange)="toggleMemberSelection(member)">
              <nz-avatar [nzSrc]="member.avatar ? member.avatar : null"
                         [nzText]="!member.avatar ? (member.label | capitalize) : null"
                         [ngClass]="{'inactive-member': !isMemberActive(member)}"
                         [ngStyle]="{'background-color': getBackgroundColor(member.label), 'color': '#fff'}">
              </nz-avatar>
            {{ isMemberActive(member) ? member.label : member.label + ' (Inactive)' }}
          </label>
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>
